import './Loader.css'


const Loader = () => {
    return (
        <div className="lds-ripple row mx-auto"><div></div><div></div></div>
    )
}

export default Loader
